/*
 * pf-slide-enlace.js — PhotoFury, 16/08/2026
 *
 * Guarda de arrastre para los banners clicables del slider de portada.
 *
 * El problema: el slider pasa de banner con desplazamiento tactil. Si el cliente
 * arrastra el dedo sobre el banner para ver el siguiente, al soltar el navegador
 * dispara el clic del enlace y se lo lleva a la ficha del producto sin querer.
 *
 * La regla: si entre `pointerdown` y `pointerup` el puntero se ha movido mas de
 * UMBRAL pixeles, se cancela la navegacion de ese clic.
 *
 * Encargo: 01-DESARROLLO/20260816-encargo-slider-clicable.md
 */
(function () {
  'use strict';

  var UMBRAL = 10; // px de tolerancia: por debajo es un toque, por encima es un arrastre

  function preparar(enlace) {
    if (enlace.dataset.pfGuardaPuesta === 'si') return;
    enlace.dataset.pfGuardaPuesta = 'si';

    var x0 = 0;
    var y0 = 0;
    var arrastrado = false;

    enlace.addEventListener('pointerdown', function (e) {
      x0 = e.clientX;
      y0 = e.clientY;
      arrastrado = false;
    });

    enlace.addEventListener('pointermove', function (e) {
      if (arrastrado) return;
      if (Math.abs(e.clientX - x0) > UMBRAL || Math.abs(e.clientY - y0) > UMBRAL) {
        arrastrado = true;
      }
    });

    // El clic solo se cancela si venia de un arrastre. La navegacion por teclado
    // (Intro sobre el enlace) no pasa por pointerdown, asi que nunca se bloquea.
    enlace.addEventListener('click', function (e) {
      if (!arrastrado) return;
      e.preventDefault();
      e.stopPropagation();
      arrastrado = false;
    });

    // NOTA (16/08/2026): aqui habia ademas una clase `pf-arrastrando` en el slider que
    // ponia el enlace en `pointer-events: none` mientras se arrastraba. Se ha quitado:
    // la clase se retiraba dentro de `requestAnimationFrame`, y en una pestaña oculta rAF
    // no se ejecuta, asi que la clase se quedaba pegada y el banner dejaba de responder
    // para siempre. El `preventDefault` del clic de arriba ya cubre el caso, y no puede
    // quedarse en un estado bloqueado.

    // Arrastrar la imagen nativa del navegador tambien confunde al slider.
    var img = enlace.parentElement && enlace.parentElement.querySelector('img');
    if (img) img.setAttribute('draggable', 'false');
  }

  function iniciar() {
    document.querySelectorAll('[data-pf-slide-enlace]').forEach(preparar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor de temas repinta las secciones: hay que volver a poner la guarda.
  document.addEventListener('shopify:section:load', iniciar);
})();
